// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellOutlinedSvg from "@fishx/icons-svg/es/asn/BellOutlined";
import FishxIcon from '../components/FishxIcon';

var BellOutlined = function BellOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellOutlinedSvg
  }));
};

BellOutlined.displayName = 'BellOutlined';
export default React.forwardRef(BellOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BellOutlined.js
// module id = 2069
// module chunks = 0